import * as React from 'react';
import * as Immutable from 'immutable';
import MiniSkillMasterEditor from 'common/entity/skillMaster/MiniSkillMasterEditor';
import classnames from 'classnames';

import { MultiSkillSelector } from 'common/entity/components/skill';
import { Skill } from 'common/models/internal/Skill';
import { SkillId } from 'common/models/internal/SkillId';

class EntitySkillsInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isSkillFormVisible: false,
            skills: props?.skills,
            isLoading: props?.isLoading
        };
    }

    componentDidUpdate(prevProps) {
        const { isLoading } = this.props;
        if (prevProps.isLoading !== isLoading) {
            this.setState({ isLoading });
        }
    }

    onShowSkillForm = () => {
        this.setState({ isSkillFormVisible: true });
    };

    onHideSkillForm = newSkill => {
        this.setState({ isSkillFormVisible: false });
        this.refershSkills();
        let { value = [] } = this.props;
        const { clientId, id } = newSkill;
        if (clientId && id) {
            value = [
                ...value,
                SkillId.fromJS({
                    clientId,
                    id
                })
            ];
            this.props.onChange(Immutable.List(value));
        }
    };

    refershSkills = () => {
        const { refreshSkills } = this.props;
        if (refreshSkills) {
            this.setState({ isLoading: true });
            refreshSkills().then(data => {
                const skills =
                    data && data.skills.map(skill => Skill.fromJS(skill));
                this.setState({ skills, isLoading: false });
            });
        }
    };

    getFooter = () => {
        const { translationsObject, theme } = this.props;
        return (
            <div className={theme.addEntityBtn} onClick={this.onShowSkillForm}>
                {`+ ${translationsObject.addSkillsText}`}
            </div>
        );
    };

    render() {
        const {
            clientId,
            teams,
            value,
            translationsObject,
            onChange,
            theme,
            testId,
            field
        } = this.props;
        const { isSkillFormVisible, skills, isLoading } = this.state;
        return (
            <div className={theme.fieldGroup} data-test-id={field.accessor}>
                <div className={theme.row}>
                    {translationsObject.label ? (
                        <span
                            className={classnames(
                                theme.label,
                                theme.horizontal
                            )}
                        >
                            {translationsObject.label}
                        </span>
                    ) : null}
                </div>
                <MultiSkillSelector
                    testId={testId}
                    clientId={clientId}
                    skills={skills}
                    value={value}
                    theme={theme}
                    onChange={onChange}
                    isLoading={isLoading}
                    footer={this.getFooter()}
                />
                {isSkillFormVisible ? (
                    <MiniSkillMasterEditor
                        theme={theme}
                        defaultSelectedTeams={teams}
                        onDismiss={this.onHideSkillForm}
                    />
                ) : null}
            </div>
        );
    }
}

export default EntitySkillsInput;
